// @todo: build a custom html element for this
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".featured-products-slider")
    .forEach((container) => {
      const scrollbar = container.querySelector(
        ".featured-products-slider__scrollbar"
      );
      const scrollbarThumb = scrollbar.querySelector(
        ".featured-products-slider__scrollbar-thumb"
      );
      const productContainer = container.querySelector(".overflow-x-auto");
      const products = container.querySelectorAll(
        ".featured-products-slider__product"
      );

      productContainer.addEventListener("scroll", () => {
        const scrollPercentage =
          (productContainer.scrollLeft /
            (productContainer.scrollWidth - productContainer.clientWidth)) *
          100;
        const thumbPosition =
          (scrollPercentage *
            (scrollbar.clientWidth - scrollbarThumb.clientWidth)) /
          100;
        scrollbarThumb.style.transform = `translateX(${thumbPosition}px)`;
      });

      const productWidth = products[0].offsetWidth;

      container
        .querySelector(".featured-products-slider__button--prev")
        ?.addEventListener("click", () => {
          productContainer.scrollBy({
            left: -productWidth,
            behavior: "smooth",
          });
        });

      container
        .querySelector(".featured-products-slider__button--next")
        ?.addEventListener("click", () => {
          productContainer.scrollBy({
            left: productWidth,
            behavior: "smooth",
          });
        });

      let isDragging = false;
      let startX;
      let scrollLeft;

      scrollbarThumb.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.pageX - scrollbarThumb.offsetLeft;
        scrollLeft = productContainer.scrollLeft;
      });

      document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollbar.getBoundingClientRect().left;
        const walk =
          (x - startX) * (productContainer.scrollWidth / scrollbar.clientWidth);
        productContainer.scrollLeft = scrollLeft + walk;
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
      });

      scrollbar.addEventListener("click", (e) => {
        const clickPosition =
          e.clientX - scrollbar.getBoundingClientRect().left;
        const scrollPosition =
          (clickPosition / scrollbar.clientWidth) *
          (productContainer.scrollWidth - productContainer.clientWidth);
        productContainer.scrollLeft = scrollPosition;
      });
    });
});
